<script lang="ts" setup>
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <v-chip class="bg-grey-darken-2 text-uppercase font-weight-600" density="comfortable" size="small">{{
    t("trucks.truck-replaced")
  }}</v-chip>
</template>

<style lang="scss" scoped>
.v-chip {
  border-radius: 4px;
}
</style>
